import React from 'react';
import { MenuItemLink } from '../components/Link';
import {
  DialogTrigger,
  Menu,
  Popover,
  SubmenuTrigger,
} from 'react-aria-components';
import {
  MenuItemStyled,
  MaterialSymbol,
  Drawer,
  Button,
} from '@moonjellydigital/react-components';

const SiteMenu = () => {
  return (
    <Menu aria-label="site">
      <MenuItemStyled
        href="https://www.sheridanprizeforart.com/"
        label="Home"
      />
      <MenuItemStyled
        href="https://www.sheridanprizeforart.com/philosophy/"
        label="Philosophy"
      />
      <MenuItemStyled
        href="https://www.sheridanprizeforart.com/donation/"
        label="Donate"
      />
      <MenuItemStyled
        href="https://www.sheridanprizeforart.com/contact/"
        label="Contact"
      />
      <SubmenuTrigger>
        <MenuItemStyled
          label="Buy Art Here"
          trailingIcon={<MaterialSymbol icon="shopping_cart" />}
        />
        <Popover placement="bottom left">
          <Menu aria-label="shop" className={'sp-siteMenu__submenu'}>
            <MenuItemStyled
              href="https://sheridanprizeforart.com/shop/"
              label="Store"
            />
            <MenuItemStyled
              href="https://sheridanprizeforart.com/cart/"
              label="Cart"
            />
            <MenuItemStyled
              href="https://sheridanprizeforart.com/checkout/"
              label="Checkout"
            />
          </Menu>
        </Popover>
      </SubmenuTrigger>
      <MenuItemStyled
        href="https://www.sheridanprizeforart.com/rules/"
        label="Prize Rules"
      />
      <MenuItemLink to="/" label="My Prize Account" />
    </Menu>
  );
};

export const SiteNav = () => {
  return (
    <DialogTrigger>
      <div className="appshell-mobileMenu">
        <Button
          classes={'appshell-burger'}
          style={{
            border: 'solid 1px var(--app-shell-on-surface)',
            width: '44px',
            height: '44px',
          }}
        >
          <MaterialSymbol icon="menu" />
        </Button>
        <Drawer title="Sheridan Prize for Art" position="right">
          <SiteMenu />
        </Drawer>
      </div>
    </DialogTrigger>
  );
};
